import { LayersControl, TileLayer } from 'react-leaflet';
import { map } from '../config';

const TileLayers = () => {
  return (
    <LayersControl position="bottomleft">
      <LayersControl.BaseLayer checked name="Default">
        <TileLayer
          attribution={map.primaryTileLayerAttribution}
          url={map.primaryTileLayerUrl}
          minZoom={map.minZoomLevel}
          minNativeZoom={map.minZoomLevel}
          maxZoom={map.maxZoomLevel}
          maxNativeZoom={map.maxZoomLevel}
          detectRetina
        />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="Satellite">
        <TileLayer
          attribution={map.satelliteTileLayerAttribution}
          url={map.satelliteTileLayerUrl}
        />
      </LayersControl.BaseLayer>
    </LayersControl>
  );
};

export default TileLayers;
